var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg4Green = function Svg4Green(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-success-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.286 30.906v1.696h-1.328V35H51.09v-2.398h-5.57V31.32l3.984-7.523h2.125l-3.774 7.11h3.235V27.75h1.867v3.156h1.328Z",
    fill: "#fff"
  })));
};

export default Svg4Green;